<mat-card class="move-bittings-dialog">
  <!-- Header -->
  <mat-card-header class="dialog-header">
    <mat-card-title>Move Bittings</mat-card-title>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <!-- Content -->
  <mat-card-content class="dialog-content">
    <!-- Source Info -->
    <div class="source-info">
      <div class="info-row">
        <span class="label">Source Book ID:</span>
        <span class="value">{{ sourceBookId }}</span>
      </div>
      <div class="info-row">
        <span class="label">Bittings Selected:</span>
        <span class="value">{{ selectedBittings?.length || 0 }}</span>
      </div>
      <div class="bittings-list" *ngIf="selectedBittings?.length > 0">
        <span class="label">Bitting Values:</span>
        <div class="bitting-chips">
          <span class="bitting-chip" *ngFor="let bitting of selectedBittings">
            {{ bitting.masterKeyBitting }}
          </span>
        </div>
      </div>
    </div>

    <mat-divider class="divider"></mat-divider>

    <!-- Destination Selection -->
    <form [formGroup]="moveForm">
      <div class="destination-section">
        <label class="section-label">Move To:</label>

        <mat-radio-group formControlName="destinationType" class="radio-group">
          <mat-radio-button value="new" class="radio-option">
            New Book
          </mat-radio-button>
          <mat-radio-button value="existing" class="radio-option">
            Existing Book
          </mat-radio-button>
        </mat-radio-group>

        <!-- Existing Book Input -->
        <div *ngIf="destinationType === 'existing'" class="book-id-input">
          <mat-form-field appearance="outline" class="book-id-field">
            <mat-label>Destination Book ID</mat-label>
            <input
              matInput
              formControlName="destinationBookId"
              type="text"
              placeholder="Enter Book ID"
              (keyup)="onBookIdKeyUp()"
            />
            <mat-error *ngIf="moveForm.get('destinationBookId')?.hasError('required')">
              Book ID is required
            </mat-error>
            <mat-error *ngIf="moveForm.get('destinationBookId')?.hasError('pattern')">
              Please enter a valid numeric Book ID
            </mat-error>
            <mat-error *ngIf="moveForm.get('destinationBookId')?.hasError('sameAsSource')">
              Destination cannot be the same as source book
            </mat-error>
          </mat-form-field>
        </div>

        <!-- New Book Key Selection -->
        <div *ngIf="destinationType === 'new'" class="key-select-section">
          <mat-form-field appearance="outline" class="key-select-field">
            <mat-label>Select Key</mat-label>
            <input
              matInput
              formControlName="destinationKeyId"
              [matAutocomplete]="keyAuto"
              placeholder="Enter key name"
            />
            <mat-autocomplete #keyAuto="matAutocomplete" [displayWith]="displayKeyName">
              <mat-option *ngFor="let key of filteredKeys" [value]="key">
                {{ key.keySetSymbol }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="moveForm.get('destinationKeyId')?.hasError('required')">
              Please select a key
            </mat-error>
          </mat-form-field>
          <div class="new-book-info" *ngIf="selectedKeyName">
            <mat-icon>info_outline</mat-icon>
            <span>A new book will be created under "{{ selectedKeyName }}"</span>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>

  <!-- Actions -->
  <mat-card-actions class="dialog-actions">
    <button mat-stroked-button (click)="close()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      (click)="move()"
      [disabled]="!isFormValid()"
    >
      Move
    </button>
  </mat-card-actions>
</mat-card>
